import { BUSINESS_TYPE_RETAIL } from "../../constants";
import { useUserStore } from "../../state";
import { useCompanyStore } from "../../state/useCompanyStore";

const useRetailBusinessStatus = () => {
  const user = useCompanyStore((state) => state.company);
  const businessType = user?.businessType || "";
  const isRetailBusiness = businessType === BUSINESS_TYPE_RETAIL;
  return isRetailBusiness;
};

export default useRetailBusinessStatus;
